import { BaseRequest } from '@/network/requests/BaseRequest';
import { model } from '@/interfaces/model';

export const modelRequest = BaseRequest.build<model>('model');